/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthorizeService, JwtHelperService, IUser } from 'msslib';
import { ClubHubDataService } from 'applib';

@Injectable({
  providedIn: 'root',
})
export class ExternalLoginService {
  private readonly authService = inject(AuthorizeService);
  private readonly clubHubDataService = inject(ClubHubDataService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);

  loginExternalUser() {
    const tokenParam = this.activatedRoute.snapshot.queryParams['key'];
    const apiKey = this.activatedRoute.snapshot.queryParams.apikey;
    if (tokenParam) {
      this.setupExternalAuth(tokenParam);
    }
    if (apiKey) {
      this.clubHubDataService.post('ExternalLogin', { apiKey }).subscribe((response: any) => {
        this.setupExternalAuth(response.token);
      });
    }
  }

  login(): void {
    const params = {

      grant_type: 'client_credentials',
      scope: 'any_scopes',
      client_id: 'client_id',
      client_secret: 'client_secret',

    };

    const searchParams = Object.keys(params)
      .map((key: string) => {
        return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
      })
      .join('&');

    fetch(this.authService.tokenEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      body: searchParams,
    }).then(async (response) => {
      const token = await response.json();
      this.setupExternalAuth(token);
    }, this.onError);
  }

  setupExternalAuth(token: string) {
    const user = new JwtHelperService().decodeToken(token) as IUser;
    sessionStorage.clear();
    sessionStorage.setItem(this.authService.tokenKey, JSON.stringify({ access_token: token, token_type: 'Bearer' }));
    const settings = {
      encryptedSettings: this.activatedRoute.snapshot.queryParams['settings'],
      clientID: this.activatedRoute.snapshot.queryParams['client'],
    };
    sessionStorage.setItem('settings', JSON.stringify(settings));
    this.authService.setUser(user).subscribe(() => {
      // Get colors from URL
      let color = this.activatedRoute.snapshot.queryParams['color'];
      if (/^(?:[0-9a-fA-F]{3}){1,2}$/.test(color) === false) {
        color = undefined;
      }

      this.router.navigateByUrl(`smartrfit/residential?color=${color}`);
    });
  }

  private onError() {
    // no-op
  }
}
